import React from 'react'
import { connect } from 'react-redux'
import { Loader } from 'components/UIElements'
import UserPage from '../components/UserPage'
import { actions } from '../modules/Users'

const mapStateToProps = ({ users, loading, searchTerm }) => {
  return {
    list: users.list,
    loading: loading.general,
    searchTerm
  }
}

const mapDispatchToProps = actions

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(props => (props.loading ? <Loader /> : <UserPage {...props} />))
